module.exports = __webpack_public_path__ + "static/img/ikona_cw1-OFF.8c4be846.png";